import BossModel from "@/models/BossModel";

export default class Day extends BossModel {
    /**
     *
     * @type {string}
     */
    static apiUrl = 'margin/group/day';

    /**
     *
     * @type {string}
     */
    static entity = 'marginGroupDays';

    static fields() {
		return {
			id: this.attr(null),
			margin_group_id: this.attr(null),
			day_of_week: this.attr(null),
		}
	}
}
